import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
// import { ProfileApi } from "../../../Redux/action/MasterAction";
// import { adminMainUrl } from '../../../Config';
import { Image } from 'antd';
import { adminMainUrl } from '../Config';
import { ProfileApi } from '../Redux/action/MasterAction';
import { Link } from 'react-router-dom';
const ProfilePage = () => {
    const [activeTab, setActiveTab] = useState("about");

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };
    const dispatch = useDispatch();
    const {
        loadingProfile,
        ProfileData,
        ProfileDataError,
    } = useSelector((state) => state?.MasterReducer);
    useEffect(() => {
        dispatch(ProfileApi(adminMainUrl));
    }, [adminMainUrl]);
    // const ProfilePage = () => {

    return (
        <div className="page-wrapper">
            <div className="content">
                <div className="row">
                    <div className="col-md-12">
                        {/* Page Header */}
                        <div className="page-header">
                            <div className="row align-items-center">
                                <div className="col-sm-4">
                                    <h4 className="page-title">
                                        View Profile Page
                                    </h4>
                                </div>
                                <div className="col-sm-8 text-sm-end">
                                    <div className="head-icons">
                                        {/* <a
                                            href="#"
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            data-bs-original-title="Refresh"
                                        >
                                            <i className="ti ti-refresh-dot" />
                                        </a> */}
                                        <a
                                            href="javascript:void(0);"
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            data-bs-original-title="Collapse"
                                            id="collapse-header"
                                        >
                                            <i className="ti ti-chevrons-up" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* /Page Header */}
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        {/* Contact User */}
                        <div className="contact-head">
                            <div className="row align-items-center">
                                <div className="col-sm-6">
                                    <ul className="contact-breadcrumb">
                                        <li>
                                            <Link to={-1}>
                                                <i className="ti ti-arrow-narrow-left" />
                                                View Profile Page
                                            </Link>
                                        </li>

                                    </ul>
                                </div>
                                {/* <div className="col-sm-6 text-sm-end">
                                    <div className="contact-pagination">
                                        <p>1 of 40</p>
                                        <ul>
                                            <li>
                                                <a href="#">
                                                    <i className="ti ti-chevron-left" />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <i className="ti ti-chevron-right" />
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <div className="card">
                            <div className="card-body pb-2">
                                <div className="d-flex align-items-center justify-content-between flex-wrap">
                                    <div className="d-flex align-items-center mb-2">
                                        <div className="avatar avatar-xxl online online-sm me-3 flex-shrink-0">
                                            <img src="/assets/img/profiles/avatar-14.jpg" alt="img" />
                                            <span className="status online" />
                                        </div>
                                        <div>
                                            <h5 className="mb-1">{ProfileData?.data?.first_name} {ProfileData?.data?.middle_name} {ProfileData?.data?.last_name}</h5>
                                            <p className="mb-2">{ProfileData?.data?.offical_contact_email}</p>
                                            <div className="d-flex align-items-center">
                                                <span className="badge badge-light bg-light-600 text-default me-3">
                                                    <i className="ti ti-lock me-1" />
                                                    {ProfileData?.data?.role?.name}
                                                </span>
                                                {/* <p className="d-inline-flex align-items-center mb-0">
                                                    <i className="fa-solid fa-star text-warning me-1" /> 5.0
                                                </p> */}
                                            </div>
                                        </div>
                                    </div>

                                    {/* <div className="contacts-action">
                                     

                                        <a
                                            href="#"
                                            className="btn btn-danger"
                                            data-bs-toggle="offcanvas"
                                            data-bs-target="#offcanvas_add_2"
                                        >
                                            <i className="ti ti-circle-plus" />
                                            Add Deal
                                        </a>
                                        <a
                                            href="#"
                                            className="btn btn-primary"
                                            data-bs-toggle="modal"
                                            data-bs-target="#add_compose"
                                        >
                                            <i className="ti ti-mail" />
                                            Send Email
                                        </a>
                                       
                                    </div> */}
                                </div>
                            </div>
                        </div>
                        {/* /Contact User */}
                    </div>
                    {/* Contact Sidebar */}
                    <div className="col-xl-4 ">
                        <div className="card">
                            <div className="card-body p-3">
                                <h6 className="mb-3 fw-semibold">Permanent Address:</h6>
                                <div className="mb-3">
                                    <div className="d-flex align-items-center mb-3">
                                        {/* <span className="avatar avatar-xs bg-light-300 p-0 flex-shrink-0 rounded-circle text-dark me-2">
                                            <i className="ti ti-mail" />
                                        </span> */}
                                        <p>{ProfileData?.data?.EmplyPermanentAddress?.postal_code} El Caminito Street, Los Angeles, LA 91214</p>
                                    </div>
                                    {/* <div className="d-flex align-items-center mb-3">
                                        <span className="avatar avatar-xs bg-light-300 p-0 flex-shrink-0 rounded-circle text-dark me-2">
                                            <i className="ti ti-phone" />
                                        </span>
                                        <p>2848 El Caminito Street, Los Angeles, LA 91214</p>
                                    </div> */}
                                    {/* <div className="d-flex align-items-center mb-3">
                                        <span className="avatar avatar-xs bg-light-300 p-0 flex-shrink-0 rounded-circle text-dark me-2">
                                            <i className="ti ti-map-pin" />
                                        </span>
                                        <p>22, Ave Street, Newyork, USA</p>
                                    </div> */}
                                    {/* <div className="d-flex align-items-center mb-3">
                                        <span className="avatar avatar-xs bg-light-300 p-0 flex-shrink-0 rounded-circle text-dark me-2">
                                            <i className="ti ti-calendar-exclamation" />
                                        </span>
                                        <p>Created at formatDate(viewData?.createdAt)</p>
                                    </div> */}
                                </div>
                                <hr />
                                <h6 className="mb-3 fw-semibold">Residential Address:</h6>
                                <div className="mb-3">
                                    <div className="d-flex align-items-center mb-3">
                                        {/* <span className="avatar avatar-xs bg-light-300 p-0 flex-shrink-0 rounded-circle text-dark me-2">
                                            <i className="ti ti-mail" />
                                        </span> */}
                                        <p>{ProfileData?.data?.EmplyPermanentAddress?.postal_code} El Caminito Street, Los Angeles, LA 91214</p>
                                    </div>
                                    {/* <div className="d-flex align-items-center mb-3">
                                        <span className="avatar avatar-xs bg-light-300 p-0 flex-shrink-0 rounded-circle text-dark me-2">
                                            <i className="ti ti-phone" />
                                        </span>
                                        <p>viewData?.phone</p>
                                    </div> */}
                                    {/* <div className="d-flex align-items-center mb-3">
                                        <span className="avatar avatar-xs bg-light-300 p-0 flex-shrink-0 rounded-circle text-dark me-2">
                                            <i className="ti ti-map-pin" />
                                        </span>
                                        <p>22, Ave Street, Newyork, USA</p>
                                    </div> */}
                                    {/* <div className="d-flex align-items-center mb-3">
                                        <span className="avatar avatar-xs bg-light-300 p-0 flex-shrink-0 rounded-circle text-dark me-2">
                                            <i className="ti ti-calendar-exclamation" />
                                        </span>
                                        <p>Created at formatDate(viewData?.createdAt)</p>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /Contact Sidebar */}
                    {/* Contact Details */}
                    <div className="col-xl-8">
                        <div className="card mb-3">
                            <div className="card-body pb-0 pt-2">
                                <ul className="nav nav-tabs nav-tabs-bottom" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <a
                                            href="#"
                                            data-bs-toggle="tab"
                                            data-bs-target="#activities"
                                            className="nav-link active"
                                        >
                                            <i className="ti ti-alarm-minus me-1" />
                                            Personal Details
                                        </a>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <a
                                            href="#"
                                            data-bs-toggle="tab"
                                            data-bs-target="#notes"
                                            className="nav-link"
                                        >
                                            <i className="ti ti-notes me-1" />
                                            Official Information

                                        </a>
                                    </li>

                                </ul>
                            </div>
                        </div>
                        {/* Tab Content */}
                        <div className="tab-content pt-0">
                            {/* Activities */}
                            <div className="tab-pane active show" id="activities">
                                <div className="card">
                                    {/* <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                        <h4 className="fw-semibold">Activities</h4>
                                        <div>
                                            <div className="form-sort mt-0">
                                                <i className="ti ti-sort-ascending-2" />
                                                <select className="select">
                                                    <option>Sort By Date</option>
                                                    <option>Ascending</option>
                                                    <option>Descending</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div> */}
                                    <div className="card-body">
                                        <div className="pb-4 px-md-4 px-3 view-info-box">

                                            <div className="row">
                                                <div className=" col-md-12 py-2">
                                                    <div className="d-flex justify-content-start gap-2 py-2">
                                                        <p className="font-medium">Contact Number: </p>
                                                        {/* <div className="box-query"> */}

                                                        <p className="mb-0 text-sm">viewData?.origin</p>
                                                        {/* </div> */}
                                                    </div>
                                                    <div className="d-flex justify-content-start gap-2 py-2">
                                                        <p className="font-medium">Gender:</p>
                                                        {/* <div className="box-query"> */}
                                                        <p className="mb-0 text-sm">viewData?.destination</p>
                                                        {/* </div> */}
                                                    </div>
                                                    <div className="d-flex justify-content-start gap-2 py-2">
                                                        <p className="font-medium">Marital Status:</p>
                                                        {/* <div className="box-query"> */}
                                                        <p className="mb-0 text-sm">viewData?.product_name</p>
                                                        {/* </div> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="badge badge-soft-purple fs-14 fw-normal shadow-none mb-3">
                                            <i className="ti ti-calendar-check me-1" />
                                            29 Aug 2023
                                        </div>
                                        <div className="card border shadow-none mb-3">
                                            <div className="card-body p-3">
                                                <div className="d-flex">
                                                    <span className="avatar avatar-md flex-shrink-0 rounded me-2 bg-pending">
                                                        <i className="ti ti-mail-code" />
                                                    </span>
                                                    <div>
                                                        <h6 className="fw-medium mb-1">
                                                            You sent 1 Message to the contact.
                                                        </h6>
                                                        <p>10:25 pm</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card border shadow-none mb-3">
                                            <div className="card-body p-3">
                                                <div className="d-flex">
                                                    <span className="avatar avatar-md flex-shrink-0 rounded me-2 bg-secondary-success">
                                                        <i className="ti ti-phone" />
                                                    </span>
                                                    <div>
                                                        <h6 className="fw-medium mb-1">
                                                            Denwar responded to your appointment schedule question
                                                            by call at 09:30pm.
                                                        </h6>
                                                        <p>09:25 pm</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card border shadow-none mb-3">
                                            <div className="card-body p-3">
                                                <div className="d-flex">
                                                    <span className="avatar avatar-md flex-shrink-0 rounded me-2 bg-orange">
                                                        <i className="ti ti-notes" />
                                                    </span>
                                                    <div>
                                                        <h6 className="fw-medium mb-1">
                                                            Notes added by Antony
                                                        </h6>
                                                        <p className="mb-1">
                                                            Please accept my apologies for the inconvenience
                                                            caused. It would be much appreciated if it's possible
                                                            to reschedule to 6:00 PM, or any other day that week.
                                                        </p>
                                                        <p>10.00 pm</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="badge badge-soft-purple fs-14 fw-normal shadow-none mb-3">
                                            <i className="ti ti-calendar-check me-1" />
                                            28 Feb 2024
                                        </div>
                                        <div className="card border shadow-none mb-3">
                                            <div className="card-body p-3">
                                                <div className="d-flex">
                                                    <span className="avatar avatar-md flex-shrink-0 rounded me-2 bg-info">
                                                        <i className="ti ti-user-pin" />
                                                    </span>
                                                    <div>
                                                        <h6 className="fw-medium mb-1 d-inline-flex align-items-center flex-wrap">
                                                            Meeting With{" "}
                                                            <span className="avatar avatar-xs mx-2">
                                                                <img
                                                                    src="assets/img/profiles/avatar-19.jpg"
                                                                    alt="img"
                                                                />
                                                            </span>{" "}
                                                            Abraham
                                                        </h6>
                                                        <p>Schedueled on 05:00 pm</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card border shadow-none mb-3">
                                            <div className="card-body p-3">
                                                <div className="d-flex">
                                                    <span className="avatar avatar-md flex-shrink-0 rounded me-2 bg-secondary-success">
                                                        <i className="ti ti-notes" />
                                                    </span>
                                                    <div>
                                                        <h6 className="fw-medium mb-1">
                                                            Drain responded to your appointment schedule question.
                                                        </h6>
                                                        <p>09:25 pm</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="badge badge-soft-purple fs-14 fw-normal shadow-none mb-3">
                                            <i className="ti ti-calendar-check me-1" />
                                            Upcoming Activity
                                        </div>
                                        <div className="card border shadow-none mb-0">
                                            <div className="card-body p-3">
                                                <div className="d-flex">
                                                    <span className="avatar avatar-md flex-shrink-0 rounded me-2 bg-info">
                                                        <i className="ti ti-user-pin" />
                                                    </span>
                                                    <div>
                                                        <h6 className="fw-medium mb-1">Product Meeting</h6>
                                                        <p className="mb-1">
                                                            A product team meeting is a gathering of the
                                                            cross-functional product team — ideally including team
                                                            members from product, engineering, marketing, and
                                                            customer support.
                                                        </p>
                                                        <p>25 Jul 2023, 05:00 pm</p>
                                                        <div className="upcoming-info">
                                                            <div className="row">
                                                                <div className="col-sm-4">
                                                                    <p>Reminder</p>
                                                                    <div className="dropdown">
                                                                        <a
                                                                            href="#"
                                                                            className="dropdown-toggle"
                                                                            data-bs-toggle="dropdown"
                                                                            aria-expanded="false"
                                                                        >
                                                                            <i className="ti ti-clock-edit me-1" />
                                                                            Reminder
                                                                            <i className="ti ti-chevron-down ms-1" />
                                                                        </a>
                                                                        <div className="dropdown-menu dropdown-menu-right">
                                                                            <a
                                                                                className="dropdown-item"
                                                                                href="javascript:void(0);"
                                                                            >
                                                                                Remainder
                                                                            </a>
                                                                            <a
                                                                                className="dropdown-item"
                                                                                href="javascript:void(0);"
                                                                            >
                                                                                1 hr
                                                                            </a>
                                                                            <a
                                                                                className="dropdown-item"
                                                                                href="javascript:void(0);"
                                                                            >
                                                                                10 hr
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-sm-4">
                                                                    <p>Task Priority</p>
                                                                    <div className="dropdown">
                                                                        <a
                                                                            href="#"
                                                                            className="dropdown-toggle"
                                                                            data-bs-toggle="dropdown"
                                                                            aria-expanded="false"
                                                                        >
                                                                            <i className="ti ti-square-rounded-filled me-1 text-danger circle" />
                                                                            High
                                                                            <i className="ti ti-chevron-down ms-1" />
                                                                        </a>
                                                                        <div className="dropdown-menu dropdown-menu-right">
                                                                            <a
                                                                                className="dropdown-item"
                                                                                href="javascript:void(0);"
                                                                            >
                                                                                <i className="ti ti-square-rounded-filled me-1 text-danger circle" />
                                                                                High
                                                                            </a>
                                                                            <a
                                                                                className="dropdown-item"
                                                                                href="javascript:void(0);"
                                                                            >
                                                                                <i className="ti ti-square-rounded-filled me-1 text-success circle" />
                                                                                Low
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-sm-4">
                                                                    <p>Assigned to</p>
                                                                    <div className="dropdown">
                                                                        <a
                                                                            href="#"
                                                                            className="dropdown-toggle"
                                                                            data-bs-toggle="dropdown"
                                                                            aria-expanded="false"
                                                                        >
                                                                            <img
                                                                                src="assets/img/profiles/avatar-19.jpg"
                                                                                alt="img"
                                                                                className="avatar-xs"
                                                                            />
                                                                            John
                                                                            <i className="ti ti-chevron-down ms-1" />
                                                                        </a>
                                                                        <div className="dropdown-menu dropdown-menu-right">
                                                                            <a
                                                                                className="dropdown-item"
                                                                                href="javascript:void(0);"
                                                                            >
                                                                                <img
                                                                                    src="assets/img/profiles/avatar-19.jpg"
                                                                                    alt="img"
                                                                                    className="avatar-xs"
                                                                                />
                                                                                John
                                                                            </a>
                                                                            <a
                                                                                className="dropdown-item"
                                                                                href="javascript:void(0);"
                                                                            >
                                                                                <img
                                                                                    src="assets/img/profiles/avatar-15.jpg"
                                                                                    alt="img"
                                                                                    className="avatar-xs"
                                                                                />
                                                                                Peter
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                            {/* /Activities */}
                            {/* Notes */}
                            <div className="tab-pane fade" id="notes">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="pb-4 px-md-4 px-3 view-info-box">
                                            <div className="row">
                                                <div className=" col-md-12 py-2">
                                                    <div className="d-flex justify-content-start gap-2 py-2">
                                                        <p className="font-medium">Contact Number:</p>
                                                        {/* <div className="box-query"> */}

                                                        <p className="mb-0 text-sm">{ProfileData?.data?.offical_contact_number}</p>
                                                        {/* </div> */}
                                                    </div>
                                                    <div className="d-flex justify-content-start gap-2 py-2">
                                                        <p className="font-medium">Email:</p>
                                                        {/* <div className="box-query"> */}
                                                        <p className="mb-0 text-sm">{ProfileData?.data?.offical_contact_email}</p>
                                                        {/* </div> */}
                                                    </div>
                                                    <div className="d-flex justify-content-start gap-2 py-2">
                                                        <p className="font-medium">Department:</p>
                                                        {/* <div className="box-query"> */}
                                                        <p className="mb-0 text-sm">{ProfileData?.data?.departments?.name}</p>
                                                        {/* </div> */}
                                                    </div>
                                                    <div className="d-flex justify-content-start gap-2 py-2">
                                                        <p className="font-medium">Designation:                                                    </p>
                                                        {/* <div className="box-query"> */}
                                                        <p className="mb-0 text-sm">{ProfileData?.data?.designation?.name}</p>
                                                        {/* </div> */}
                                                    </div>
                                                    <div className="d-flex justify-content-start gap-2 py-2">
                                                        <p className="font-medium">Role:</p>
                                                        {/* <div className="box-query"> */}
                                                        <p className="mb-0 text-sm">{ProfileData?.data?.role?.name}</p>
                                                        {/* </div> */}
                                                    </div>
                                                    <div className="d-flex justify-content-start gap-2 py-2">
                                                        <p className="font-medium">Reporting Manager:</p>
                                                        {/* <div className="box-query"> */}
                                                        <p className="mb-0 text-sm">Sakshi jain</p>
                                                        {/* </div> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                        <h4 className="fw-semibold">Notes</h4>
                                        <div className="d-inline-flex align-items-center">
                                            <div className="form-sort me-3 mt-0">
                                                <i className="ti ti-sort-ascending-2" />
                                                <select className="select">
                                                    <option>Sort By Date</option>
                                                    <option>Ascending</option>
                                                    <option>Descending</option>
                                                </select>
                                            </div>
                                            <a
                                                href="javascript:void(0);"
                                                data-bs-toggle="modal"
                                                data-bs-target="#add_notes"
                                                className="link-purple fw-medium"
                                            >
                                                <i className="ti ti-circle-plus me-1" />
                                                Add New
                                            </a>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="notes-activity">
                                            <div className="card mb-3">
                                                <div className="card-body">
                                                    <div className="d-flex align-items-center justify-content-between pb-2">
                                                        <div className="d-inline-flex align-items-center mb-2">
                                                            <span className="avatar avatar-md me-2 flex-shrink-0">
                                                                <img
                                                                    src="assets/img/profiles/avatar-19.jpg"
                                                                    alt="img"
                                                                />
                                                            </span>
                                                            <div>
                                                                <h6 className="fw-medium mb-1">Darlee Robertson</h6>
                                                                <p className="mb-0">15 Sep 2023, 12:10 pm</p>
                                                            </div>
                                                        </div>
                                                        <div className="mb-2">
                                                            <div className="dropdown">
                                                                <a
                                                                    href="#"
                                                                    className="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                >
                                                                    <i className="ti ti-dots-vertical" />
                                                                </a>
                                                                <div className="dropdown-menu dropdown-menu-right">
                                                                    <a
                                                                        className="dropdown-item"
                                                                        href="javascript:void(0);"
                                                                    >
                                                                        <i className="ti ti-edit text-blue me-1" />
                                                                        Edit
                                                                    </a>
                                                                    <a
                                                                        className="dropdown-item"
                                                                        href="javascript:void(0);"
                                                                    >
                                                                        <i className="ti ti-trash text-danger me-1" />
                                                                        Delete
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <h5 className="fw-medium mb-1">Notes added by Antony</h5>
                                                    <p>
                                                        A project review evaluates the success of an initiative
                                                        and identifies areas for improvement. It can also
                                                        evaluate a current project to determine whether it's on
                                                        the right track. Or, it can determine the success of a
                                                        completed project.{" "}
                                                    </p>
                                                    <div className="d-inline-flex align-items-center flex-wrap">
                                                        <div className="note-download me-3">
                                                            <div className="note-info">
                                                                <span className="note-icon bg-secondary-success">
                                                                    <i className="ti ti-file-spreadsheet" />
                                                                </span>
                                                                <div>
                                                                    <h6 className="fw-medium mb-1">
                                                                        Project Specs.xls
                                                                    </h6>
                                                                    <p>365 KB</p>
                                                                </div>
                                                            </div>
                                                            <a href="javascript:void(0);">
                                                                <i className="ti ti-arrow-down" />
                                                            </a>
                                                        </div>
                                                        <div className="note-download">
                                                            <div className="note-info">
                                                                <span className="note-icon">
                                                                    <img
                                                                        src="assets/img/media/media-35.jpg"
                                                                        alt="img"
                                                                    />
                                                                </span>
                                                                <div>
                                                                    <h6 className="fw-medium mb-1">090224.jpg</h6>
                                                                    <p>365 KB</p>
                                                                </div>
                                                            </div>
                                                            <a href="javascript:void(0);">
                                                                <i className="ti ti-arrow-down" />
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <div className="notes-editor">
                                                        <div className="note-edit-wrap">
                                                            <div className="">
                                                                Write a new comment, send your team notification by
                                                                typing @ followed by their name
                                                            </div>
                                                            <div className="text-end note-btns">
                                                                <a
                                                                    href="javascript:void(0);"
                                                                    className="btn btn-light add-cancel"
                                                                >
                                                                    Cancel
                                                                </a>
                                                                <a
                                                                    href="javascript:void(0);"
                                                                    className="btn btn-primary"
                                                                >
                                                                    Save
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div className="text-end">
                                                            <a
                                                                href="javascript:void(0);"
                                                                className="add-comment link-purple fw-medium"
                                                            >
                                                                <i className="ti ti-square-plus me-1" />
                                                                Add Comment
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card mb-3">
                                                <div className="card-body">
                                                    <div className="d-flex align-items-center justify-content-between pb-2">
                                                        <div className="d-inline-flex align-items-center mb-2">
                                                            <span className="avatar avatar-md me-2 flex-shrink-0">
                                                                <img
                                                                    src="assets/img/profiles/avatar-20.jpg"
                                                                    alt="img"
                                                                />
                                                            </span>
                                                            <div>
                                                                <h6 className="fw-medium mb-1">Sharon Roy</h6>
                                                                <p className="mb-0">18 Sep 2023, 09:52 am</p>
                                                            </div>
                                                        </div>
                                                        <div className="mb-2">
                                                            <div className="dropdown">
                                                                <a
                                                                    href="#"
                                                                    className="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                >
                                                                    <i className="ti ti-dots-vertical" />
                                                                </a>
                                                                <div className="dropdown-menu dropdown-menu-right">
                                                                    <a
                                                                        className="dropdown-item"
                                                                        href="javascript:void(0);"
                                                                    >
                                                                        <i className="ti ti-edit text-blue me-1" />
                                                                        Edit
                                                                    </a>
                                                                    <a
                                                                        className="dropdown-item"
                                                                        href="javascript:void(0);"
                                                                    >
                                                                        <i className="ti ti-trash text-danger me-1" />
                                                                        Delete
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <h5 className="fw-medium mb-1">Notes added by Antony</h5>
                                                    <p>
                                                        A project plan typically contains a list of the
                                                        essential elements of a project, such as stakeholders,
                                                        scope, timelines, estimated cost and communication
                                                        methods. The project manager typically lists the
                                                        information based on the assignment.
                                                    </p>
                                                    <div className="d-inline-flex align-items-center flex-wrap">
                                                        <div className="note-download me-3">
                                                            <div className="note-info">
                                                                <span className="note-icon bg-secondary-success">
                                                                    <i className="ti ti-file-text" />
                                                                </span>
                                                                <div>
                                                                    <h6 className="fw-medium mb-1">Andrewpass.txt</h6>
                                                                    <p>365 KB</p>
                                                                </div>
                                                            </div>
                                                            <a href="javascript:void(0);">
                                                                <i className="ti ti-arrow-down" />
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <div className="reply-box">
                                                        <p>
                                                            The best way to get a project done faster is to start
                                                            sooner. A goal without a timeline is just a dream.The
                                                            goal you set must be challenging. At the same time, it
                                                            should be realistic and attainable, not impossible to
                                                            reach.
                                                        </p>
                                                        <p>
                                                            Commented by{" "}
                                                            <span className="text-purple">Aeron</span> on 15 Sep
                                                            2023, 11:15 pm
                                                        </p>
                                                        <a href="#" className="btn">
                                                            <i className="ti ti-arrow-back-up-double" />
                                                            Reply
                                                        </a>
                                                    </div>
                                                    <div className="notes-editor">
                                                        <div className="note-edit-wrap">
                                                            <div className="">
                                                                Write a new comment, send your team notification by
                                                                typing @ followed by their name
                                                            </div>
                                                            <div className="text-end note-btns">
                                                                <a
                                                                    href="javascript:void(0);"
                                                                    className="btn btn-light add-cancel"
                                                                >
                                                                    Cancel
                                                                </a>
                                                                <a
                                                                    href="javascript:void(0);"
                                                                    className="btn btn-primary"
                                                                >
                                                                    Save
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div className="text-end">
                                                            <a
                                                                href="javascript:void(0);"
                                                                className="add-comment link-purple fw-medium"
                                                            >
                                                                <i className="ti ti-square-plus me-1" />
                                                                Add Comment
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card mb-0">
                                                <div className="card-body">
                                                    <div className="d-flex align-items-center justify-content-between pb-2">
                                                        <div className="d-inline-flex align-items-center mb-2">
                                                            <span className="avatar avatar-md me-2 flex-shrink-0">
                                                                <img
                                                                    src="assets/img/profiles/avatar-21.jpg"
                                                                    alt="img"
                                                                />
                                                            </span>
                                                            <div>
                                                                <h6 className="fw-medium mb-1">Vaughan</h6>
                                                                <p className="mb-0">20 Sep 2023, 10:26 pm</p>
                                                            </div>
                                                        </div>
                                                        <div className="mb-2">
                                                            <div className="dropdown">
                                                                <a
                                                                    href="#"
                                                                    className="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                >
                                                                    <i className="ti ti-dots-vertical" />
                                                                </a>
                                                                <div className="dropdown-menu dropdown-menu-right">
                                                                    <a
                                                                        className="dropdown-item"
                                                                        href="javascript:void(0);"
                                                                    >
                                                                        <i className="ti ti-edit text-blue me-1" />
                                                                        Edit
                                                                    </a>
                                                                    <a
                                                                        className="dropdown-item"
                                                                        href="javascript:void(0);"
                                                                    >
                                                                        <i className="ti ti-trash text-danger me-1" />
                                                                        Delete
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <p>
                                                        Projects play a crucial role in the success of
                                                        organizations, and their importance cannot be
                                                        overstated. Whether it's launching a new product,
                                                        improving an existing
                                                    </p>
                                                    <div className="notes-editor">
                                                        <div className="note-edit-wrap">
                                                            <div className="">
                                                                Write a new comment, send your team notification by
                                                                typing @ followed by their name
                                                            </div>
                                                            <div className="text-end note-btns">
                                                                <a
                                                                    href="javascript:void(0);"
                                                                    className="btn btn-light add-cancel"
                                                                >
                                                                    Cancel
                                                                </a>
                                                                <a
                                                                    href="javascript:void(0);"
                                                                    className="btn btn-primary"
                                                                >
                                                                    Save
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div className="text-end">
                                                            <a
                                                                href="javascript:void(0);"
                                                                className="add-comment link-purple fw-medium"
                                                            >
                                                                <i className="ti ti-square-plus me-1" />
                                                                Add Comment
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                            {/* /Notes */}

                            {/* /Email */}
                        </div>
                        {/* /Tab Content */}
                    </div>
                    {/* /Contact Details */}
                </div>
            </div>
            {/* <QuotationAirExportModal show={show} handleClose={handleClose} /> */}
            {/* {
                viewData !== null &&
                <RemarkModal viewData={viewData} show={showRemark} handleClose={handleCloseRemark} />} */}
        </div>

    )
}

export default ProfilePage